import {
  APIErrorResponse,
  isAPIErrorResponse
} from '@arc-publishing/sdk-subs-core/lib/utils/APIErrorResponse';
import JSONResponseHandler from '@arc-publishing/sdk-subs-core/lib/utils/JSONResponseHandler';

import { AMPReaderIdResponse } from './logoutAMPReaderID';
import { headers } from './constants';
import { getOptions, getValidURL } from './utils';
import AMP from './amp';

/**
 * Gets the AMPReaderID for the current user.
 *
 * @returns __Promise__ which resolves to an object containing login status for AMPReaderID. If an AMPReaderID does not exist, date values will be null and linkedArcIdentity will be false.
 *
 * <details>
 *  <summary>
 *    On success (resolves)
 *  </summary>
 *
 * array
 *
 * </details>
 *
 * <details>
 *  <summary>
 *    On error (throws)
 *  </summary>
 * </details>
 */

export default async function authenticateAMPReaderID(
  ampReaderId: string
): Promise<APIErrorResponse | AMPReaderIdResponse> {
  const options: Object = await getOptions({ method: 'GET', headers });
  const url = typeof window !== 'undefined' ? getValidURL(AMP.apiOrigin) : AMP.apiOrigin;

  return fetch(`${url}/sales/public/v1/amp/${ampReaderId}`, options)
    .then(JSONResponseHandler)
    .then((json: APIErrorResponse | AMPReaderIdResponse) => {
      if (isAPIErrorResponse(json)) {
        throw json;
      } else {
        return json;
      }
    });
}
